export default __webpack_public_path__ + "static/media/ml.ab624980.jpg";